// Removed unused TranslationValue type

/**
 * Deep merge with English fallback
 * @param base - English translations (complete)
 * @param overlay - Target language translations (may be partial)
 * @returns Merged object with overlay values taking precedence
 */
export function mergeTranslations<T extends object>(
  base: T,
  overlay: Partial<T>
): T {
  const result = { ...base }

  for (const key in overlay) {
    const baseValue = base[key]
    const overlayValue = overlay[key]

    if (
      overlayValue !== undefined &&
      typeof baseValue === 'object' &&
      !Array.isArray(baseValue) &&
      baseValue !== null &&
      typeof overlayValue === 'object' &&
      !Array.isArray(overlayValue) &&
      overlayValue !== null
    ) {
      // Recursive merge for nested objects
      result[key] = mergeTranslations(baseValue, overlayValue) as T[Extract<keyof T, string>]
    } else if (
      overlayValue !== undefined &&
      typeof overlayValue === 'string' &&
      overlayValue.trim() !== ''
    ) {
      // Use overlay value if it's a non-empty string
      result[key] = overlayValue as T[Extract<keyof T, string>]
    }
    // Otherwise keep base value (English fallback)
  }

  return result
}
